import React, { Component } from "react";
import {
  Input,
  Button,
  GridContainer,
  GridRow,
  GridColumn,
  Toastr,
  Utils,
} from "arv-reactcomponents";
import PropTypes from "prop-types";
import { Login } from "arv-extends";
import { observer, inject } from "mobx-react";
import { CORPORATE_GIFTING_COMPONENTS } from "npmlinks-constants";
import Banner from "../Banner";
import RequiredField from "../../RequiredField";

const { EmailInput, MobileNumberInput } = Login;

@inject("CommonStore")
@observer
class RemarksForm extends Component {
  constructor() {
    super();
    this.state = {
      name: "",
      company: "",
      city: "",
      remark: "",
      pincode: "",
      quantity: "",
    };
    this.emailFields = null;
    this.mobileNoFields = null;
    this.WhatsAppMobileNoFields = null;
    this.updateValue = this.updateValue.bind(this);
    this.sendForm = this.sendForm.bind(this);
  }
  updateValue(event, type) {
    const {
      target: { value },
    } = event;
    switch (type) {
      case "name":
        this.setState({ name: value });
        break;
      case "company":
        this.setState({ company: value });
        break;
      case "city":
        this.setState({ city: value });
        break;
      case "pincode":
        this.setState({ pincode: value });
        break;
      case "quantity":
        this.setState({ quantity: value });
        break;
      default:
        this.setState({ remark: value });
        break;
    }
  }

  get finalFormData() {
    const { name, company, city, remark, pincode, quantity } = this.state;

    return {
      name,
      company,
      city,
      remark,
      email: this.emailFields.state.email,
      mobileNo: this.mobileNoFields.state.mobileNumber || "",
      pincode,
      quantity,
    };
  }

  sendForm() {
    const { name, city, quantity, pincode } = this.state;

    if (
      !name ||
      !this.emailFields.state.isEmailInputValid ||
      !this.mobileNoFields.state.isMobileInputValid ||
      !city
    ) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.MANDATORY,
        timeout: 3000,
      });
    } else if (!this.isNameValid) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.INVALID_NAME,
        timeout: 3000,
      });
    } else if (
      this.mobileNoFields.state.mobileNumber &&
      !this.mobileNoFields.state.isMobileInputValid
    ) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message:
          CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.IMPROPER_PHONE,
        timeout: 3000,
      });
    } else if (quantity && (isNaN(quantity) || Number(quantity) < 1)) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message:
          CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.INVALID_QUANTITY,
        timeout: 3000,
      });
    } else if (pincode && (pincode.length !== 6 || isNaN(pincode))) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message:
          CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.INVALID_PINCODE,
        timeout: 3000,
      });
    } else {
      this.props.CommonStore.triggerCorporateGifting(this.finalFormData).then(
        () => {
          Toastr.showToastr({
            className: "nwc-toastr-list-success nw-toastr",
            message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.SUCCESS,
            timeout: 3000,
          });
        },
        () => {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.ERROR,
            timeout: 3000,
          });
        },
      );
    }
  }

  get isNameValid() {
    const { name } = this.state;
    return (
      name &&
      name.length > 0 &&
      name.match(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/i)
    );
  }

  render() {
    const { name, remark, company, city, pincode, quantity } = this.state;

    return (
      <GridContainer
        className={`${this.props.containerclassName}`}
        onClick={Utils.preventEventPropagation}
      >
        <GridRow className="nw-mobile-only">
          <GridColumn>
            <Banner
              text={CORPORATE_GIFTING_COMPONENTS.REMARKS_FORM_TITLE}
              className="wc-banner-container"
            />
          </GridColumn>
        </GridRow>
        <GridRow className="wc-remarksform-main">
          <GridColumn
            className={`nwc-grid-col-xs-12 wc-remarksform-container ${
              this.props.formclassName
            }`}
          >
            <form>
              <Banner
                text={CORPORATE_GIFTING_COMPONENTS.REMARKS_FORM_TITLE}
                className="wc-banner-container nw-desktop-only"
              />
              <RequiredField
                className="nwc-inp  wc-remarksform-input "
                required
              >
                <Input
                  name="name"
                  required="required"
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={e => this.updateValue(e, "name")}
                />
              </RequiredField>

              <EmailInput.component
                className="wc-remarksform-input wc-remarksform-inputmargin"
                name="email"
                type="email"
                placeholder="Email"
                ref={values => {
                  this.emailFields = values;
                }}
                required
              />
              <MobileNumberInput.component
                className="wc-remarksform-input wc-remarksform-inputmargin"
                name="mobile-number"
                type="text"
                placeholder="Mobile Number"
                ref={values => {
                  this.mobileNoFields = values;
                }}
                required
              />

              <Input
                className="wc-remarksform-input"
                name="company-name"
                type="text"
                placeholder="Company Name"
                value={company}
                onChange={e => this.updateValue(e, "company")}
              />

              <div>
                <RequiredField
                  className="nwc-inp  wc-remarksform-input"
                  required
                >
                  <Input
                    name="city"
                    required="required"
                    type="text"
                    placeholder="City"
                    value={city}
                    onChange={e => this.updateValue(e, "city")}
                  />
                </RequiredField>
                <Input
                  className="wc-remarksform-input"
                  name="pincode"
                  type="text"
                  placeholder="Pincode"
                  value={pincode}
                  onChange={e => this.updateValue(e, "pincode")}
                />
                <Input
                  className="wc-remarksform-input"
                  name="quantity"
                  type="text"
                  placeholder="Quantity"
                  value={quantity}
                  onChange={e => this.updateValue(e, "quantity")}
                />
                <Input
                  className="wc-remarksform-input"
                  name="remark"
                  type="text"
                  placeholder="Remark"
                  value={remark}
                  onChange={e => this.updateValue(e, "remark")}
                />
              </div>
              <Button
                className="nwc-btn-primary wc-remarksform-btn"
                onClick={this.sendForm}
              >
                {CORPORATE_GIFTING_COMPONENTS.REMARKS_FORM_BUTTON_TEXT}
              </Button>
            </form>
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

RemarksForm.wrappedComponent.propTypes = {
  containerclassName: PropTypes.string.isRequired,
  formclassName: PropTypes.string.isRequired,
  CommonStore: PropTypes.shape({
    triggerCorporateGifting: PropTypes.func.isRequired,
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export default RemarksForm;
